module.exports = "/assets/data/c6a5de76cb454475dff96da2d12076b7-BN41.data.json";